import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
    wrapper: {
        '& .MuiPopover-paper': {
            // transition: 'none !important',
            // top: '25px !important',
        },
    },
    userInfo: {
        display: 'flex',
        flexDirection: 'column',
        cursor: 'pointer',
        padding: '2px 0px 2px 12px',

        '& p': {
            margin: '0 10px',
            fontSize: '16px',
            color: '#444',

            [theme.breakpoints.down('md')]: {
                margin: '0 7px',
                fontSize: '14px',
            },
        },
    },
    itemContainer: {
        display: 'flex',
        alignItems: 'center',
        height: '46px',

        '&:hover': {
            '& p, svg': {
                color: theme.palette.primary.main,
            },
        },
    },
    rounded: {
        color: '#fff',
        backgroundColor: theme.palette.primary.main,
        fontSize: '16px',

        [theme.breakpoints.down('md')]: {
            height: '36px',
            width: '36px',
        },
    },
    downIcon: {
        color: theme.palette.secondary.main,
    },
    icon: {
        width: '40px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',

        [theme.breakpoints.down('md')]: {
            width: '36px',
        },
    },
}));
